export default __webpack_public_path__ + "static/media/sort-desc.3a7bb09e.svg";